import { defineMessages } from 'react-intl';

export default defineMessages({
    range: {
        id: 'rangeDatePicker.range',
        defaultMessage: '{from} - {to}',
    },
})
